import { Button, Drawer, Radio, Row, Space } from 'antd';
import React, { useEffect, useState } from "react";
import "./MobileViewFilter.css";
import FilterIcon from "../../assets/img/filtericon.svg";
import SortIcon from "../../assets/img/sorticon.svg";
import PrivateGigsTag from "../../pages/SearchSkillListing/components/AllGigs/PrivateGigsTag";
import { useSelector } from "react-redux";
import SearchDropDown from "../../pages/SearchSkillListing/components/LocationFilter/SearchDropDown";
import SkillDropDown from "../../pages/SearchSkillListing/components/LocationFilter/SkillDropDown";
import ExperienceFilter from "../../pages/SearchSkillListing/components/LocationFilter/ExperienceFilter";
import { FILTER_KEYS } from '../../pages/SearchSkillListing/components/AllGigs/AllGigsFilter';
import PrivateTag from "../../assets/icons/PrivateTag.svg";
import { BILLING_ELIGIBLE_SOURCE } from "../../shared/billing";
const MobileViewFilter = ({
  searchFilters,
  setGigType,
  GigType,
  gigStatus,
  setGigStatus,
  isMobileView,
  handleApplyDropDown,
  selectedCities,
  setSelectedCities,
  selectedStates,
  setSelectedStates,
  selectedSkill,
  setSelectedSkill,
  selectedExperience,
  setSelectedExperience,
  selectedCountries,
  setSelectedCountries,
  experienceOptions,
  selectedGigType,
  setSelectedGigType,
  applyMobileFilters,
  clearAll,
  sortType,
  setSortType,
  searchText,
  mobileButtonsPadding,
  showGigStatus,
  selectedVMS,
  setSelectedVMS,
  selectedFacility,
  setSelectedFacility,
  defaultParams = {},
}) => {
  const Count = useSelector((state) => state.manageJobsReducer.counts);
  const [open, setOpen] = useState(false);
  const [showSortDrawer, setShowSortDrawer] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const userSource = String(
    userProfile?.Source || localStorage.getItem("cognitoSource") || ""
  )
    .trim()
    .toLowerCase();
  const isPtmEmployer =
    String(userProfile?.PvtEmpName || "").trim().toLowerCase() === "sg-ptm";
  const canShowPtmFilters =
    isPtmEmployer && userSource !== BILLING_ELIGIBLE_SOURCE;
  const showDrawer = () => {
    setOpen(true);
    setShowSortDrawer(false);
  };

  const onClose = () => {
    setOpen(false);
    setShowSortDrawer(false);
    getFilterCount();
  };

  const onChange = (e) => {
    setGigType(e.target.value);
  };

  const applyFilter = () => {
    onClose();
    getFilterCount();
    applyMobileFilters({
      isPrivateGig: GigType,
      _sort: sortType,
      ...searchFilters,
    });
  };
  const handleSortType = (e) => {
    // Setting only publised gigs for upcoming expiry
    if(e.target.value=='ENDING')
    setGigStatus('Published')
    setSortType(e.target.value);
  };

  const getFilterCount = () => {
    let count = 0;
    if (searchFilters?.countries?.length) {
      count++;
    }
    if (GigType) {
      count++;
    }
    if (gigStatus) {
      count++;
    }
    if (searchFilters?.cities?.length) {
      count++;
    }
    if (searchFilters?.regions?.length) {
      count++;
    }
    if (searchFilters?.Skills?.length) {
      count++;
    }
    if (searchFilters?.explevel) {
      count++;
    }
    if (searchFilters?.JobOrderTypeName) {
      count++;
    }
    if (searchFilters?.vms?.length) {
      count++;
    }
    if (searchFilters?.facility?.length) {
      count++;
    }
    setFilterCount(count);
  };

  useEffect(() => {
    getFilterCount();
  }, [searchFilters]);

  return (
    <div>
      {isMobileView && (
        <Row
          style={{
            justifyContent: "space-between",
            width: "99%",
            marginTop: "3px",
            padding: mobileButtonsPadding,
          }}
        >
          <div className="filter-button1" onClick={showDrawer}>
            <img className={"filter-button-icon"} alt="" src={FilterIcon} />
            <div className={"filter-button-text"}>
              Filter {filterCount > 0 ? `(${filterCount})` : null}
            </div>
          </div>

          <div
            className="filter-button2"
            onClick={() => setShowSortDrawer(true)}
          >
            <img className={"filter-button-icon"} alt="" src={SortIcon} />
            <div className={"filter-button-text"}>Sort</div>
          </div>
        </Row>
      )}
      <Drawer
        title={
          <div className="Drawer-filter-pvt-mkt">
            <div
              onClick={() => {
                clearAll();
              }}
            >
              Clear All
            </div>
            <div>Filter</div>
          </div>
        }
        height={"100%"}
        placement={"top"}
        closable={false}
        onClose={onClose}
        open={isMobileView && open}
        key={"sort"}
        footer={
          <>
            <Button
              onClick={() => applyFilter()}
              className="footer-primary-pvt"
              type="primary"
            >
              Apply Filter
            </Button>
          </>
        }
      >
        <div>
          {userProfile?.IsPrivateEmployer ? <><div className="Mobile-filter-title-pvt">{"All jobs"}</div>
              <div className="Radio-grop-pvt-mkt">
                <Radio.Group onChange={onChange} value={GigType}>
                  <Space className="Space-radio-pvt-mkt" direction="vertical">
                    <Radio value={false}>
                      <span>All jobs</span>
                      <span>
                        {/* (
                        {Count?.totalCount
                          ? Count?.totalCount?.[0]?.allGigs
                            ? Count?.totalCount?.[0]?.allGigs
                            : 0
                          : 0}
                        ) */}
                      </span>
                    </Radio>
                    <Radio value={true}>
                      <span>
                        Private jobs{" "}
                        <img
                          style={{ marginTop: "3px", marginLeft: "3px" }}
                          src={PrivateTag}
                          alt="private"
                        />
                      </span>
                      <span>
                        {/* (
                        {Count?.totalCount
                          ? Count?.totalCount[0]?.isPrivate
                            ? Count?.totalCount[0]?.isPrivate
                            : 0
                          : 0}
                        ) */}
                      </span>
                    </Radio>
                  </Space>
                </Radio.Group>
            </div></> : null}

          {/* Job Status */}
          {showGigStatus && (
            <>
              <div className="Mobile-filter-title-pvt">Job status</div>
              <div className="Radio-grop-pvt-mkt">
                <Radio.Group
                  onChange={(e) => setGigStatus(e?.target?.value)}
                  value={gigStatus||'All'}
                >
                  <Space className="Space-radio-pvt-mkt" direction="vertical">
                    <Radio value={false}>
                      <span>All</span>
                      <span>
                        (
                        {Count?.totalCount
                          ? Count?.totalCount[0]?.all
                            ? Count?.totalCount[0]?.all
                            : 0
                          : 0}
                        )
                      </span>
                    </Radio>
                    <Radio value={"Published"}>
                      <span>Published</span>
                      <span>
                        (
                        {Count?.totalCount
                          ? Count?.totalCount[0]?.published
                            ? Count?.totalCount[0]?.published
                            : 0
                          : 0}
                        )
                      </span>
                    </Radio>
                    <Radio value={"Expired"}>
                      <span>Expired</span>
                      <span>
                        (
                        {Count?.totalCount
                          ? Count?.totalCount[0]?.expired
                            ? Count?.totalCount[0]?.expired
                            : 0
                          : 0}
                        )
                      </span>
                    </Radio>
                    <Radio value={"Deleted"}>
                      <span>Deleted</span>
                      <span>
                        (
                        {Count?.totalCount
                          ? Count?.totalCount[0]?.deleted
                            ? Count?.totalCount[0]?.deleted
                            : 0
                          : 0}
                        )
                      </span>
                    </Radio>
                  </Space>
                </Radio.Group>
              </div>
            </>
          )}
          <div className="Mobile-filter-title-pvt">Job Type</div>
          <ExperienceFilter
            label="Job Type"
            isSelected={false}
            filterKey={FILTER_KEYS.JobOrderTypeName}
            isMobileView={true}
            handleApply={handleApplyDropDown}
            value={searchFilters?.JobOrderTypeName}
            selectedOptions={selectedGigType}
            setSelectedOptions={setSelectedGigType}
            defaultParams={defaultParams}
          />
          <div className="Mobile-filter-title-pvt">Skill</div>
          <SkillDropDown
            filterKey={"SkillsId"}
            isSelected={searchFilters?.SkillsId}
            label={"Skill"}
            paramKey="skill"
            isMobileView={true}
            // handleApply={() => {}}
            handleApply={handleApplyDropDown}
            searchFilters={searchFilters}
            selectedOptions={selectedSkill}
            setSelectedOptions={setSelectedSkill}
            drawerTitle="Select Skill/Skills"
            searchText={searchText}
            defaultParams={defaultParams}
          />
          <div className="Mobile-filter-title-pvt">Country</div>
          <SearchDropDown
            filterKey={"CountryId"}
            isSelected={true}
            label={"Country"}
            paramKey="country"
            isMobileView={true}
            handleApply={handleApplyDropDown}
            selectedOptions={selectedCountries}
            setSelectedOptions={setSelectedCountries}
            searchText={searchText}
            searchFilters={searchFilters}
            drawerTitle="Select Country/Countries"
            defaultParams={defaultParams}
          />
          <div className="Mobile-filter-title-pvt">State</div>
          <SearchDropDown
            filterKey={"RegionId"}
            isSelected={false}
            label={"State"}
            paramKey="region"
            handleApply={handleApplyDropDown}
            isMobileView={true}
            searchFilters={searchFilters}
            selectedOptions={selectedStates}
            setSelectedOptions={setSelectedStates}
            searchText={searchText}
            drawerTitle="Select State/States"
            defaultParams={defaultParams}
          />
          <div className="Mobile-filter-title-pvt">City</div>
          <SearchDropDown
            filterKey={"CityId"}
            isSelected={false}
            label={"City"}
            handleApply={handleApplyDropDown}
            isMobileView={true}
            searchFilters={searchFilters}
            selectedOptions={selectedCities}
            setSelectedOptions={setSelectedCities}
            searchText={searchText}
            drawerTitle="Select City/Cities"
            defaultParams={defaultParams}
          />
          <div className="Mobile-filter-title-pvt">Experience Level</div>

          <ExperienceFilter
            label="Experience Level"
            filterKey={FILTER_KEYS.ExperienceLevel}
            isSelected={false}
            isMobileView={true}
            handleApply={handleApplyDropDown}
            value={searchFilters.explevel}
            selectedOptions={selectedExperience}
            setSelectedOptions={setSelectedExperience}
            defaultParams={defaultParams}
          />
         
         {canShowPtmFilters && (
  <>
    <div className="Mobile-filter-title-pvt">VMS</div>
    <SearchDropDown
      filterKey={FILTER_KEYS.vms}
      isSelected={searchFilters?.vms?.length}
      label={"VMS"}
      paramKey="vms"
      isMobileView={true}
      handleApply={handleApplyDropDown}
      searchFilters={searchFilters}
      selectedOptions={selectedVMS}
      setSelectedOptions={setSelectedVMS}
      searchText={searchText}
      drawerTitle="Select VMS"
      defaultParams={defaultParams}
    />
    <div className="Mobile-filter-title-pvt">Facility</div>
    <SearchDropDown
      filterKey={FILTER_KEYS.FacilityId}
      isSelected={searchFilters?.FacilityId?.length}
      label="Facility"
      paramKey="facility"
      isMobileView={true}
      handleApply={handleApplyDropDown}
      searchFilters={searchFilters}
      selectedOptions={selectedFacility}
      setSelectedOptions={setSelectedFacility}
      searchText={searchText}
      drawerTitle="Select facility"
      defaultParams={defaultParams}
      vmsSelected={selectedVMS}
    />
  </>
)}
        </div>
      </Drawer>

      <Drawer
        title={
          <div className="Drawer-filter-pvt-mkt">
            <div>Sort By</div>
          </div>
        }
        height={"100%"}
        placement={"top"}
        closable={false}
        onClose={onClose}
        open={isMobileView && showSortDrawer}
        key={"top"}
        footer={
          <>
            <Button
              onClick={() => applyFilter()}
              className="footer-primary-pvt"
              type="primary"
            >
              Show Results
            </Button>
          </>
        }
      >
        <div className="Radio-grop-pvt-mkt">
          <Radio.Group onChange={handleSortType} value={sortType}>
            <Space className="Space-radio-pvt-mkt" direction="vertical">
              {SORT_OPTIONS.map((el) => (
                <Radio value={el.value}>
                  <span>{el.title || "N/A"}</span>
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </div>
      </Drawer>
    </div>
  );
};

export const SORT_OPTIONS=[{title:'Most Recent',value:"MOST_RECENT"},{title:'Upcoming Expiry',value:"ENDING"}]

export default MobileViewFilter;
